import { RatingJobsActionTypes } from './constants';

type RatingJobsAction = { type: string, payload: {} | string };

export const launchRatingJob = (integrationId): RatingJobsAction => ({
    type: RatingJobsActionTypes.LAUNCH_RATING_JOB,
    payload: { integrationId },
});

export const ratingJobsApiResponseSuccess = (actionType: string, data: any): RatingJobsAction => ({
    type: RatingJobsActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});

export const ratingJobsApiResponseError = (actionType: string, error: string): RatingJobsAction => ({
    type: RatingJobsActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getRatingJobStatus = (integrationId): RatingJobsAction => ({
    type: RatingJobsActionTypes.GET_RATING_JOB_STATUS,
    payload: { integrationId },
});

export const stopRatingJob = (integrationId): RatingJobsAction => ({
    type: RatingJobsActionTypes.STOP_RATING_JOB,
    payload: { integrationId },
});

export const restartRatingJob = (integrationId): RatingJobsAction => ({
    type: RatingJobsActionTypes.RESTART_RATING_JOB,
    payload: { integrationId },
});

export const getAllRatingJobs = (): RatingJobsAction => ({
    type: RatingJobsActionTypes.GET_ALL_RATING_JOBS,
    payload: {},
});
